import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Komponent ScrollToTop
 * Automatycznie przewija stronę na górę przy każdej zmianie trasy
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // Jeśli mamy hash (np. /#sekcja) - przewiń do elementu
    if (hash) {
      const id = hash.replace('#', '')

      // Retry, bo część stron jest lazy-loadowana i DOM może jeszcze nie być gotowy
      let attempts = 0
      const maxAttempts = 12

      const tryScroll = () => {
        const el = document.getElementById(id)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          return
        }

        attempts += 1
        if (attempts < maxAttempts) {
          window.setTimeout(tryScroll, 80)
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
        }
      }

      window.setTimeout(tryScroll, 0)
      return
    }

    // Brak hash: przewiń na górę strony
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname, hash]) // Uruchamia się gdy zmienia się pathname lub hash

  return null // Komponent nie renderuje niczego
}

export default ScrollToTop

